<template>
  <label>Address</label>
  <div class="details-value">
    <div v-if="address1">{{ address1 }}</div>
    <div v-if="address2">{{ address2 }}</div>
    <div v-if="address3">{{ address3 }}</div>
    <div v-if="address4">{{ address4 }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  address_line_1: {
    type: String,
    default: ''
  },
  address_line_2: {
    type: String,
    default: ''
  },
  city: {
    type: String,
    default: ''
  },
  state: {
    type: String,
    default: ''
  },
  postal_code: {
    type: String,
    default: ''
  },
  country: {
    type: String,
    default: ''
  }
});

// null values might be passed as props, so convert to empty string
const address1 = computed(() => {
  return (props.address_line_1 ?? '').trim();
});

const address2 = computed(() => {
  return (props.address_line_2 ?? '').trim();
});

const address3 = computed(() => {
  const city = props.city ?? '';
  const state = props.state ?? '';
  const postal = props.postal_code ?? '';
  const line = `${city}${city && state ? ', ' : ''} ${state} ${postal}`;
  return line.trim();
});

const address4 = computed(() => {
  return (props.country ?? '').trim();
});
</script>

<style scoped>
@import '@/styles/shared-details.css';
</style>